<template>
  <div class="reaction-like reaction-container">
    <div class="reaction-show">
      <base-icon v-if="!haveIUpvoted"
                 name="thumb_up"
                 size="small"
                 class="caption-type"
                 role="button"
                 @click="upvote" />
      <base-icon v-if="haveIUpvoted"
                 name="thumb_up"
                 size="small"
                 class="highlighted-icon"
                 role="button"
                 @click="unvote" />
      <span class="small-type caption-type vote-count">{{ upvoteCount }}</span>
      <base-icon v-if="!haveIDownvoted"
                 name="thumb_down"
                 size="small"
                 class="caption-type"
                 role="button"
                 @click="downvote" />
      <base-icon v-if="haveIDownvoted"
                 name="thumb_down"
                 size="small"
                 class="highlighted-icon"
                 role="button"
                 @click="unvote" />
      <span class="small-type caption-type vote-count">{{ downvoteCount }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseIcon from 'vuecomponents/base_icon'
import IntlMixin from 'vuemixins/intl_mixin'
export default {
  components: { BaseIcon },
  mixins: [IntlMixin],
  props: ['isReactable', 'userId', 'reactionIds', 'reactions'],
  computed: {
    myReaction () {
      return this.reactionIds.filter((x) => this.reactions[x].user_id === this.userId)[0]
    },
    canReact () { return this.isReactable },
    upvoteCount () { return this.reactionIds.filter((x) => this.reactions[x].value === 1).length },
    downvoteCount () {
      return this.reactionIds.filter((x) => this.reactions[x].value === -1).length
    },
    haveIUpvoted () { return (this.myReaction && this.reactions[this.myReaction].value === 1)  },
    haveIDownvoted () { return (this.myReaction && this.reactions[this.myReaction].value === -1)  }
  },
  methods: {
    ...mapActions('snackbars', ['setSnackbar']),
    publishReaction (value) {
      this.$emit('create', value)
    },
    removeReaction () {
      this.$emit('delete')
    },
    showReactionOffNotice () {
      const message = this.__('Reactions have been disabled by the admin.')
      this.setSnackbar({ message })
    },
    like () {
      if (this.canReact) {
        this.publishReaction(1)
      } else {
        this.showReactionOffNotice()
      }
    },
    upvote () {
      if (this.canReact) {
        this.publishReaction(1)
      } else {
        this.showReactionOffNotice()
      }
    },
    downvote () {
      if (this.canReact) {
        this.publishReaction(-1)
      } else {
        this.showReactionOffNotice()
      }
    },
    unvote () {
      this.removeReaction()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../assets/stylesheets/3/modules/all";

.surface-post-reaction {
  background-color: rgba(black, 0.04);
  display: block;

  .reaction-container {
    padding: 8px 12px;
  }

  .reaction-star {
    .reaction-star-avg {
      margin-right: 4px;
    }
  }

  .reaction-show, .reaction-edit {
    display: flex;
    align-items: center;
    i {
      // doing this cuz we have bad i styles elsewhere
      margin-right: 4px !important;
    }

    .reaction-grade-value {
      margin-right: 4px;
    }

    .reaction-action {
      // May have to top pad 1px to make it look more aligned with the neighbours
      padding: 0 4px;
      line-height: 17px;
      font-weight: 500;
    }

    .reaction-star-count, .reaction-grade-count {
      margin-right: 4px;
      &::before {
        content: "(";
      }
      &::after {
        content: ")";
      }
    }
  }

  .reaction-show {
    overflow: hidden;
  }

  .reaction-show.reaction-editable {
    cursor: pointer;
  }

  .reaction-edit {
    justify-content: space-between;
    .caption-type {
      color: $caption-text-color !important;
    }
    .small-buttony-caption-type {
      color: $caption-text-color !important;
    }
  }

  .reaction-stars {
    display: flex;

    i {
      margin-right: 0 !important;
    }

    i:last-of-type {
      margin-right: 4px;
    }
  }

  .read-only {
    .reaction-action, .reaction-empty {
      display: none;
    }
  }

  .highlighted-icon {
    color: $material-red-500;
  }

  [data-view-mode="edit"] & .reaction-container {
    visibility: hidden;
  }

  [data-color-scheme="dark"] & .highlighted-icon {
    color: $material-yellow-accent-700;
  }

  .dropdown {
    right: initial;
    left: -8px;

    @include respondToPhone {
      left: 0;
    }
  }

  .dropdown-content {
    padding: 8px;
    min-height: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
  }

  .vote-count {
    margin-right: 8px;
  }
}
</style>
